<template>
  <div style="padding: 0 10px">
    <From @search="searchCall" :regionList="regionList" @print="print" @printCheck="() => { dialogExport = true }" />
    <!-- <Tags @search="searchTagsCall"/> -->
    <WmsTable :columns="columns" :dataSource="dataSource" @pageChange="pageChangeCall" :isPagination="query"
      :hasHeader="false">
      <ImgView slot="productImgAction" slot-scope="{ text, record, index }" :src="text" :width="40" :height="40">
      </ImgView>
      <template slot="pkgCode" slot-scope="{ text, record, index }">
        <div>{{ text }}</div>
        <template v-if="record.customerTagNameList?.length">
          <div class="customerTag" v-for="item in record.customerTagNameList" :key="item">{{ item }}</div>
        </template>
      </template>
      <template slot="productSku" slot-scope="{ text, record, index }">
        <a :href="record.productLink" target="_blank" v-if="record.productLink">
          {{ text }}
        </a>
        <span v-else>{{ text }}</span>
      </template>
      <div slot="regionName" slot-scope="{ text, record, index }">
        {{ warehouseFlag(record.regionCode) }}
      </div>
      <div slot="warehouse" slot-scope="{ text, record, index }">
        {{ regionFlag(record.warehouse) }}
      </div>
      <div slot="additionalList" slot-scope="{ adt, record }">
        <a href="#" @click.prevent="showAdt(record)">查看</a>
      </div>
      <div slot="volume" slot-scope="{ text, record }">
        <span>{{ { 'XS': '超小', 'S': '小', 'M': '中', 'L': '大', 'XL': '超大' }[text] }}</span>
        <span style="color:#409eff;cursor:pointer;margin-left: 10px" @click="changeVolume(record)">编辑</span>
      </div>
      <div slot="size" slot-scope="{ text, record }" style="display: flex;align-items: center;">
        <span>{{ record.sizeStr }}</span>
        <span style="color:#409eff;cursor:pointer;margin-left: 10px;width: 50px;" @click="changeSize(record)">编辑</span>
      </div>
      <div slot="action" slot-scope="{ text, record, index }">
        <a href="javaScript:;" @click="info(record)">查看日志</a>
        <a href="javaScript:;" @click="printPkg(record)" style="margin-left: 10px">打印</a>
        <a href="javaScript:;" @click="showDeduction(record)" style="margin-left: 10px">抵扣明细</a>
      </div>
    </WmsTable>
    <el-dialog title="日志" :visible.sync="dialog.visible" width="80%">
      <WmsTable :columns="dialog.columns" :dataSource="dialog.dataSource" :is-pagination="false" :hasHeader="false">
      </WmsTable>
    </el-dialog>
    <el-dialog title="附加项" :visible.sync="visibleAdt" width="60%">
      <WmsTable :columns="adtColumns" :dataSource="adtList" :is-pagination="false" row-key="additionName">
        <ImgView slot="Img" slot-scope="{ text }" :src="text"></ImgView>
      </WmsTable>
    </el-dialog>
    <el-dialog title="抵扣明细" :visible.sync="dialogDeduction" width="60%">
      <div style="text-align: left;font-size: 20px;">
        成品区上架时间 {{ shelvedTime }}
      </div>
      <WmsTable :columns="deductionColumns" :dataSource="deductionDataSource" :isPagination="queryDeduction"
        @pageChange="deductionPageChangeCall" v-if="dialogDeduction" :hasHeader="false" :scrollY="400">
      </WmsTable>
    </el-dialog>
    <el-dialog title="更改体积" :visible.sync="dialogVolume" width="400px">
      <el-radio-group v-model="targetPkg.volume" v-if="dialogVolume">
        <div style="text-align: left">
          <el-radio-button label="XS">超小</el-radio-button>
          <el-radio-button label="S">小</el-radio-button>
          <el-radio-button label="M">中</el-radio-button>
          <el-radio-button label="L">大</el-radio-button>
          <el-radio-button label="XL">超大</el-radio-button>
        </div>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVolume = false">取 消</el-button>
        <el-button type="primary" @click="updateVolume">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="质检明细导出" :visible.sync="dialogExport" width="600px">
      <el-form :model="exportForm" ref="exportFromRef" :rules="rules" label-width="100px">
        <el-form-item label="类型" prop="exportType">
          <div style="height: 52px;align-items: center;display: flex;">
            <el-radio-group v-model="exportForm.exportType" style="float: left;text-align: left">
              <el-radio :label="3">根据移库进质检房时间导出</el-radio>
              <el-radio :label="4">根据移库进成品区时间导出</el-radio>
              <br />
              <el-radio :label="2" style="margin-top: 10px;">导出质检房所有库存质检明细</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="数据格式" prop="dataFormat" v-if="exportForm.exportType != 2">
          <div style="height: 32px;align-items: center;display: flex;">
            <el-radio-group v-model="exportForm.dataFormat" style="float: left;">
              <el-radio :label="1">每天的数据</el-radio>
              <el-radio :label="0">汇总的数据</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="系统来源" prop="dataFormat">
          <div style="height: 32px;align-items: center;display: flex;">
            <el-radio-group v-model="exportForm.systemSource" style="float: left;">
              <el-radio :label="undefined">全部</el-radio>
              <el-radio :label="1">D2C</el-radio>
              <el-radio :label="2">B2B</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="时间" prop="time" v-if="exportForm.exportType != 2">
          <div style="height: 32px;align-items: center;display: flex;">
            <el-date-picker style="float: left" v-model="exportForm.time" type="daterange" end-placeholder="选择结束日期"
              start-placeholder="选择开始日期" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']"
              :picker-options="{
                onPick({ maxDate, minDate }) {
                  return onPickFunc({ maxDate, minDate })
                },
                disabledDate(time) {
                  return disabledDateFunc(time)
                }
              }">
            </el-date-picker>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogExport = false">取 消</el-button>
        <el-button type="primary" @click="toPrint">确 定</el-button>
      </span>
    </el-dialog>
    <ChangeSize ref="changeSizeRef" @success="getDataSource"/>
    <!-- <choosePrint ref="choosePrintDialog"></choosePrint> -->
  </div>
</template>

<script>
import { clientUrl } from "@/const/env";
import Calendar from "@/utils/calendar";
import From from "@/views/inventoryDetails/warehouseStatus/components/From";
import Tags from "@/views/inventoryDetails/warehouseStatus/components/Tags";
import WmsTable from "@/components/WmsTable";
import ImgView from "@/components/ImgView";
// import choosePrint from "@/components/choosePrint"
import {
  columns,
  columnsSon,
  deductionColumns,
} from "@/views/inventoryDetails/warehouseStatus/indexData";
import {
  RegionList,
  warehouseList,
  pkgPage,
  exportPkgState,
  pkgDeductionPage,
  batchUpdateVolume,
  exportQualityCheckDetails
} from "@/apis/inventoryDetails";
import { getIngredientsBatch } from "@/apis/checking";
import { pkgDetail } from "@/apis/abnormal";
import ChangeSize from './components/ChangeSize.vue'
export default {
  title: "仓库状态",
  name: "WarehouseStatus",
  components: {
    From,
    Tags,
    WmsTable,
    ImgView,
    ChangeSize
    // choosePrint
  },
  data() {
    return {
      clientUrl,
      columns,
      deductionColumns,
      query: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      dataSource: [],
      regionList: [],
      warehouseData: [],
      // 日志
      dialog: {
        columns: columnsSon,
        visible: false,
        dataSource: [],
      },
      visibleAdt: null,
      adtColumns: [
        {
          title: "附加项名称",
          dataIndex: "additionName",
        },
        {
          title: "辅料名称",
          dataIndex: "ingredientsName",
          customRender: (text, record, index) => {
            return record.ingredientsName || record.ingredientsNameJp;
          },
        },
        {
          title: "辅料图片",
          dataIndex: "ingredientsImg",
          scopedSlots: {
            customRender: "Img",
          },
        },
        {
          title: "辅料库位",
          dataIndex: "gridCode",
        },
      ],
      adtList: [],
      dialogVolume: false,
      targetPkg: null,
      dialogDeduction: false,
      deductionDataSource: [],
      shelvedTime: "",
      queryDeduction: {
        current: 1,
        pageSize: 10,
        total: 0,
        pkgCode: '',
      },
      dialogExport: false,
      exportForm: {
        exportType: 3,
        dataFormat: 1,
        time: '',
        systemSource: undefined
      },
      firstPickTime: '',
      rules: {
        exportType: [{ required: true, message: '请选择类型' }],
        dataFormat: [{ required: true, message: '请选择格式' }],
        time: [{ required: true, message: '请选择时间' }]
      }
    };
  },
  mounted() {
    // this.getDataSource();
    this.getRegion();
  },
  methods: {
    onPickFunc({ maxDate, minDate }) {
      console.log(maxDate, minDate)
      if (maxDate && minDate) {
        return
      }
      this.firstPickTime = new Date(minDate || maxDate).getTime()
    },
    disabledDateFunc(time) {
      if (!this.firstPickTime) {
        return false
      }
      return new Date(time).getTime() > this.firstPickTime + 2678400000 || new Date(time).getTime() < this.firstPickTime - 2678400000
    },
    searchCall: function (fromData) {
      this.formInline = fromData;
      this.query.current = 1;
      this.query.total = 1;
      this.getDataSource();
    },
    searchTagsCall: function (tag) {
      this.query.current = 1;
      this.query.total = 1;
      this.getDataSource();
    },
    pageChangeCall: function (payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getDataSource();
    },
    deductionPageChangeCall: function (payload) {
      const { current, pageSize } = payload;
      this.queryDeduction.current = current;
      this.queryDeduction.pageSize = pageSize;
      this.showDeduction({});
    },
    info: function (r) {
      this.dialog.visible = true;
      this.dialog.dataSource = r.operations;
    },
    getDataSource: function () {
      let params = {
        // checkingShelvFlag: 1,
        // combinationProductItemFlag: 1,
        pageNum: this.query.current,
        pageSize: this.query.pageSize,
        ...this.formInline,
      };
      delete params.pkgCodeList;
      this.formInline.pkgCodeList &&
        (params.pkgCodeList = this.formInline.pkgCodeList?.split(","));
      delete params.productSkus;
      this.formInline.productSkus &&
        (params.productSkus = this.formInline.productSkus?.split(","));
      if (params.pkgType && params.pkgType != "") {
        params.pkgType = [params.pkgType];
      }
      pkgPage(params).then(({ code, data }) => {
        if (code === 0) {
          this.dataSource = data.records;
          this.query.total = data.total;
        }
      });
    },
    getRegion() {
      RegionList().then(({ code, data }) => {
        if (code === 0) {
          this.regionList = data;
        }
      });
      warehouseList().then(({ code, data }) => {
        if (code === 0) {
          this.warehouseData = data;
        }
      });
    },
    regionFlag(region) {
      let warehouseName;
      this.warehouseData.forEach((item) => {
        if (region == item.wareCode) {
          warehouseName = item.wareName;
        }
      });
      return warehouseName || "-";
    },
    warehouseFlag(region) {
      let regionName;
      this.regionList.forEach((item) => {
        if (region == item.regionCode) {
          regionName = item.regionName;
        }
      });
      return regionName || "-";
    },
    toPrint() {
      this.$refs.exportFromRef.validate((val) => {
        if (val) {
          const params = {
            ...this.exportForm
          }
          params.startTime = params.time[0]
          params.endTime = params.time[1]
          delete params.time
          if (params.exportType == 2) {
            delete params.time
            delete params.dataFormat
            delete params.startTime
            delete params.endTime
          }
          exportQualityCheckDetails(params).then(res => {
            if (res.success) {
              this.$message.success('导出成功，请稍后前往数据导出中心查看')
              this.dialogExport = false
            }
          })
        }
      })
    },
    print() {
      let params = {
        // checkingShelvFlag: 1,
        // combinationProductItemFlag: 1,
        pageNum: this.query.current,
        pageSize: this.query.pageSize,
        ...this.formInline,
      };
      delete params.pkgCodeList;
      delete params.productSkus;
      this.formInline.pkgCodeList &&
        (params.pkgCodeList = this.formInline.pkgCodeList?.split(","));
      this.formInline.productSkus &&
        (params.productSkus = this.formInline.productSkus?.split(","));
      if (params.pkgType && params.pkgType != "") {
        params.pkgType = [params.pkgType];
      }
      const date = Calendar.d1(Date.now());
      exportPkgState(params).then((res) => {
        console.log(res);
        let blobObj = new Blob([res.data], {
          type: "application/octet-stream",
        });
        let blobUrl = window.URL.createObjectURL(blobObj);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = date + "仓库状态.xls";
        link.click();
        window.URL.revokeObjectURL(link.href);
      });
    },
    printPkg(record) {
      this.$wmsPrint.print().templatePrintByPkg([record]);
    },
    showAdt(v) {
      this.visibleAdt = true;
      this.adtList = [];
      pkgDetail({ pkgCode: v.pkgCode }).then((res) => {
        if (res.data) {
          console.log(res.data);
          let ingredientsSku = [];
          res.data.additionalList &&
            res.data.additionalList.forEach((item, index) => {
              if (item.ingredientsSku) {
                ingredientsSku.push(item.ingredientsSku);
              }
            });
          getIngredientsBatch(ingredientsSku).then((grideRes) => {
            for (let i in res.data.additionalList) {
              res.data.additionalList[i].ingredientsSku && grideRes.data
                ? (res.data.additionalList[i].gridCode = grideRes.data.filter(
                  (v) =>
                    v.ingredientsSku ==
                    res.data.additionalList[i].ingredientsSku
                )[0].gridCode)
                : "";
            }
            this.adtList = res.data.additionalList;
          });
        }
      });
    },
    changeVolume(r) {
      this.dialogVolume = true;
      this.targetPkg = { ...r };
    },
    updateVolume() {
      batchUpdateVolume({
        productSku: this.targetPkg.productSku,
        volume: this.targetPkg.volume
      }).then(res => {
        this.getDataSource()
        this.dialogVolume = false
      })
    },
    showDeduction(r) {
      // this.targetPkg = r
      // r?.pkgCode && (this.queryDeduction.pkgCode = r.pkgCode)
      if (r?.pkgCode) {
        this.queryDeduction.pkgCode = r.pkgCode
        this.queryDeduction.current = 1
        this.shelvedTime = r.shelvedTime
      }
      pkgDeductionPage({
        pageNum: this.queryDeduction.current,
        pageSize: this.queryDeduction.pageSize,
        pkgCode: this.queryDeduction.pkgCode,
      }).then((res) => {
        this.queryDeduction.total = res.data.total;
        this.deductionDataSource = res.data.records;
        this.dialogDeduction = true;
      });
    },
    changeSize(record){
      this.$refs.changeSizeRef.open(record)
    }
  },
};
</script>

<style scoped>
.customerTag {
  min-height: 24px;
  min-width: 24px;
  padding: 0 2px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: white;
  background-color: red;
  line-height: 24px;
  font-size: 12px;
}
</style>
